import React from 'react';
import Header from "../../User/layouts/Header";
import "../styles/pages/home.scss";
import { Typography, Container } from '@mui/material';
import WhatsApp from "../../User/components/WhatsApp";
import Footer from '../layouts/Footer';

const Refundcancellation = () => {
    return (
        <React.Fragment>
            <Header />
            <section className='about'>
                <Typography variant='h4'>Cancellation & Refund</Typography>
            </section>
            <section className='faq'>
                <Container maxWidth="xl">
                    <div className='privacy-content'>
                        <Typography variant='h5'>cancellation and refund policy:</Typography>
                        <Typography>While we do not want to lose an opportunity to serve you , we have utmost respect towards
                            your decision and we are ready to go that extra mile to serve you with the best you deserve. However
                            – </Typography>
                        <Typography>• Order can be cancelled any time before scheduling Designer Home-Consultation (available in
                            Hyderabad only at the moment) or Online Consultation over a Video Call.</Typography>
                        <Typography>• The consultation charge is fully refundable, if Designer in-person consultation is
                            cancelled 3hrs before the scheduled visit. </Typography>
                        <Typography>• Designer Consultation can be rescheduled upto 2 times.</Typography>
                        <Typography>• Consultation fee will not be refunded if the order is not placed after the
                            Home-Consultation. However, it will be converted into a coupon that can be used by Customer within
                            the given Expiry date.</Typography>
                        <Typography>• If the order is cancelled After the consultation & fabric pickup, fabric return pickup
                            needs to be managed by the Customer.</Typography>
                        <Typography>• Items once processed & delivered can not be returned/exchanged, unless they are in
                            unalterable condition. </Typography>
                        <Typography>• If our Quality Control Team finds that alteration is not possible, our team will procure &
                            provide nearest matching fabric and if that’s not possible, full refund on the bill amount will be
                            issued.</Typography>
                        <Typography>• Refund will be processed with in 7 to 10 days to the Account.</Typography>
                    </div>
                </Container>
            </section>
            <WhatsApp />
            <React.Fragment>
                <Footer />
            </React.Fragment>
        </React.Fragment>
    )
}

export default Refundcancellation